import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { CoreService, LoaderService, PortalService, RoutingService } from 'src/app/services';

@Component({
    selector: 'medpt-portal-feature-content',
    templateUrl: './portal-feature-content.component.html',
    styleUrls: ['./portal-feature-content.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PortalFeatureContentComponent implements OnInit {

  @Input() featureName = "";
  @Input() showFullContentLink = false;
  @Output() emitportalContent = new EventEmitter<any>();
  show: boolean = false;
  portalContent: string = '<div class="sm-loading text-center"></div>';
  showMoreButton: boolean = false;
  @ViewChild('portalcontentcontainer') portalcontentcontainer!: ElementRef;
  @Output() emitportalinfo = new EventEmitter<any>();
  InnerHeight = "auto";
  constructor(
    private coreService: CoreService,
    private routingService: RoutingService,
    private loaderService: LoaderService,
    private portalService: PortalService
  ) { }

  ngOnInit(): void {
    let portalInfo = this.portalService.portalConfiguation.getValue();
    this.coreService.getPortalContent(this.routingService.getSponsorName(), <number>portalInfo.PortalID, this.featureName)
      .then((portalContent) => {
        if (portalContent != null) {
          if (portalContent.ContentText != null) {
            this.portalContent = <string>portalContent.ContentText;
            this.emitportalinfo.emit(<string>portalContent.ContentText);
            //this.showFullContentLink = <bool>portalContent.showFullContent;
            if (!this.showFullContentLink) {
              setTimeout(() => {
                var height = this.portalcontentcontainer != null ? this.portalcontentcontainer.nativeElement.offsetHeight : 100;
                if (height > 100) {
                  this.InnerHeight = "100px";
                  this.showMoreButton = true;
                }
              });
            } else {
              this.show = true;
            }
          }
          else {
            this.portalContent = "";
          }
        }
        else {
          this.portalContent = "";
        }
      }, () => {

      })
      .catch(() => { })
      .finally(() => { this.emitportalContent.emit(this.portalContent);});
  }

  ngAfterViewChecked() {

  }

  showHideContent() {
    this.show = !this.show;
    this.InnerHeight = "auto";
    if (!this.show)
      this.InnerHeight = "100px";
  }

}
